import styled, { useTheme } from 'styled-components';
import Column from '../core/components/box/column';
import SizedBox from '../core/components/box/sizedBox';
import LXMiddleButton from '../core/components/buttons/lxMiddleButton';
import { LXDivider } from '../core/components/divider/lxDivider';
import {
  LXbody,
  LXbodyLong,
  LXh1,
  LXh2,
  LXh3,
  LXh4,
} from '../core/texts/lxText';
import { device, useMedia } from '../core/designSystem/device';
import BG from './assets/visionBg.jpg';

const ResponsiveBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 12px;

  width: 100%;
  max-width: 1040px;
  padding: 30px;
  background-color: ${(props) => props.theme.colors.white};
`;

const VisionAndMissionContainer = styled.div`
  width: 100%;
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 25px;
`;

const BackgoundImage = styled.div`
  position: absolute;
  width: 100%;
  padding-top: 100%;
  z-index: -1;

  background-image: url(${BG});
  background-repeat: no-repeat;
  background-position: top;
`;

const Paragraph = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 720px;
  align-items: flex-start;
  @media ${device.tabletAndBelow} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

function linkBrochure(url: string) {
  window.open(url);
}

interface VisionAndMissionProps {}
const VisionAndMission = (props: VisionAndMissionProps) => {
  const { isTabletAndBelow, isDesktop } = useMedia();
  const theme = useTheme();
  const Title = () => {
    if (isTabletAndBelow)
      return (
        <LXh2 color={theme.colors.white}>{theme.intro.visionAndMission}</LXh2>
      );
    else
      return (
        <LXh1 color={theme.colors.white}>{theme.intro.visionAndMission}</LXh1>
      );
  };

  const Brochure = () => {
    return (
      <Column justifyContent="center" alignItems="center">
        {isTabletAndBelow ? (
          <LXh2>{theme.intro.brochure}</LXh2>
        ) : (
          <LXh1>{theme.intro.brochure}</LXh1>
        )}
        <SizedBox height={4} />
        {isTabletAndBelow ? (
          <LXbody color={theme.colors.caption}>
            {theme.intro.describtionBrochure}
          </LXbody>
        ) : (
          <LXh4 fontWeight={400} color={theme.colors.caption}>
            {theme.intro.describtionBrochure}
          </LXh4>
        )}
        <SizedBox height={30} />
        <LXMiddleButton
          kind="secondary"
          onClick={() => linkBrochure('https://linktr.ee/KLab_Lab')}
        >
          {theme.intro.brochureDownload}
        </LXMiddleButton>
      </Column>
    );
  };

  const VisionAndMissionContents = () => {
    return (
      <>
        <SizedBox width={isTabletAndBelow ? 10 : 20} />
        <Paragraph>
          <LXh3
            flexShrink={0}
            width={isDesktop ? '100px' : 'undefine'}
            color={theme.colors.primary500}
          >
            {theme.intro.mission}
          </LXh3>
          <LXbodyLong maxWidth="600px" fontSize="16px" lineHeight="21px">
            {theme.intro.describtionMission}
          </LXbodyLong>
        </Paragraph>
        <LXDivider width={isTabletAndBelow ? '40%' : '720px'} margin="24px 0" />
        <Paragraph>
          <LXh3
            flexShrink={0}
            width={isDesktop ? '100px' : 'undefine'}
            color={theme.colors.primary500}
          >
            {theme.intro.vision}
          </LXh3>
          <LXbodyLong maxWidth="600px" fontSize="16px" lineHeight="21px">
            {theme.intro.describtionVision}
          </LXbodyLong>
        </Paragraph>
        <LXDivider width={isTabletAndBelow ? '40%' : '720px'} margin="24px 0" />
        <Paragraph>
          <LXh3
            flexShrink={0}
            width={isDesktop ? '100px' : 'undefine'}
            color={theme.colors.primary500}
          >
            {theme.intro.slogan}
          </LXh3>
          <LXbodyLong maxWidth="600px" fontSize="16px" lineHeight="21px">
            {theme.intro.describtionSlogan}
          </LXbodyLong>
        </Paragraph>
      </>
    );
  };
  return (
    <Column alignItems="center">
      <BackgoundImage></BackgoundImage>
      <VisionAndMissionContainer>
        <SizedBox height={isTabletAndBelow ? 150 : 240} />
        <Title />
        <SizedBox height={isTabletAndBelow ? 20 : 40} />
        <ResponsiveBox>
          <VisionAndMissionContents />
        </ResponsiveBox>
        <SizedBox height={isTabletAndBelow ? 40 : 80} />
        <LXDivider width="100%" />
        <SizedBox height={isTabletAndBelow ? 40 : 80} />
        <Brochure />
        <SizedBox height={isTabletAndBelow ? 80 : 100} />
      </VisionAndMissionContainer>
    </Column>
  );
};

export default VisionAndMission;
